import { isCountryCode } from "./countries.js"

function normalizeCountryCode(value) {
  const code = String(value || "").trim().toUpperCase()
  return /^[A-Z]{2}$/.test(code) ? code : ""
}

function headerValue(headers, name) {
  if (!headers) return ""
  if (typeof headers.get === "function") {
    return headers.get(name) || headers.get(name.toLowerCase()) || ""
  }
  const key = Object.keys(headers).find((item) => item.toLowerCase() === name.toLowerCase())
  return key ? headers[key] : ""
}

/**
 * Netlify sends the visitor IP country as `x-country` (a two-letter code)
 * and as `x-nf-geo` (base64 JSON `{ country: { code, name }, ... }`).
 * Returns "" when the header is missing or unreadable.
 */
export function countryCodeFromNetlifyGeoHeader(value) {
  const raw = Array.isArray(value) ? value[0] : value
  if (!raw || typeof raw !== "string") return ""

  try {
    const json = JSON.parse(Buffer.from(raw.trim(), "base64").toString("utf8"))
    return normalizeCountryCode(json?.country?.code)
  } catch {
    return ""
  }
}

/**
 * Country code from the request Netlify geolocated.
 * `x-country` wins. `x-nf-geo` is the fallback. "" means no preselection.
 */
export function visitorCountryFromHeaders(headers) {
  const fromCountry = normalizeCountryCode(headerValue(headers, "x-country"))
  if (fromCountry) return fromCountry
  return countryCodeFromNetlifyGeoHeader(headerValue(headers, "x-nf-geo"))
}

/** A listed alpha-2 code, or "" when the value is missing or unknown. */
export function preselectCountryCode(code) {
  const country = normalizeCountryCode(code)
  if (!country || !isCountryCode(country)) return ""
  return country
}

/**
 * Region subtag of a locale, such as `en-US` or `da-DK`.
 * A language with no region (`en`, `da`) does not invent a country.
 */
export function countryCodeFromLocale(value) {
  const first = String(value || "").split(",")[0].trim()
  const parts = first.split(/[-_]/).filter(Boolean)
  for (let i = parts.length - 1; i >= 1; i -= 1) {
    const code = preselectCountryCode(parts[i])
    if (code) return code
  }
  return ""
}
